module.exports = __webpack_public_path__ + "assets/img/star_sentence3.63c0d246.png";